<template>
  <div class="tab-body">
    <div class="operator">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="toSave()">添加</el-button>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData.records" stripe height="auto" @selection-change="selectionChange"
        v-loading="listLoading">
        <el-table-column type="selection" width="55" fixed="left"></el-table-column>
        <el-table-column prop="subtime" label="学习时间">
          <template slot-scope="scope">
            {{ getMyDate(scope.row.subtime) }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="课程+科目"></el-table-column>
        <el-table-column prop="name" label="总结标题"></el-table-column>
        <el-table-column prop="dbColumn_tid" label="审阅"></el-table-column>
        <el-table-column prop="score" label="评分">
          <template slot-scope="scope">
            <el-rate v-model="scope.row.score * 1" :colors="colors" :disabled="true">
            </el-rate>
          </template>
        </el-table-column>

       <el-table-column label="操作" fixed="right" width="200px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button type="success"  size="mini"  @click="content(scope.row)">查看</el-button>
              <el-button  size="mini"    :type="scope.row.score * 1 >0?(scope.row.score * 1<3?'danger':'primary'): ''"    @click="toUpdate(scope.$index, scope.row)">修改</el-button>
              <el-button  type="danger" size="mini" v-if="(!scope.row.score) || scope.row.score<1"      @click="remove(scope.$index, scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column> 
      </el-table>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
          :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>
    </div>
    <edit ref="edit"></edit>
    <add  ref="add"></add>
  </div>
</template>
<script>
import edit from "./edit.vue";
import add from "./add.vue";
import api from "@/api/study/feedback/feedback.js";
import qlhTable from "@/components/qlhTable/qlhTable.vue";
import qlhTableColumn from "@/components/qlhTable/qlhTableColumn.vue";
 
export default {
  name: "feedback",
  components: {
    edit,
    add,
    qlhTable,
    qlhTableColumn,
  },
  data() {
    return {
      state: '未读',
      colors: { 3: "#99A9BF", 5: "#FF9900" },
      checked: true,
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      page: new this.$constant.pageObj(),
      postsList: [],
      clazzList: {}
    };
  },
  watch: {
    "searchParams.sname": function (newVal, oldVal) {
      this.searchParams.sname = newVal;
      this.search();
    },
  },
  methods: {

    // 时间节点
    getMyDate(str) {
      var oDate = new Date(str),
        oYear = oDate.getFullYear(),
        oMonth = oDate.getMonth() + 1,
        oDay = oDate.getDate(),
        oTime = oYear + "-" + this.getzf(oMonth) + "-" + this.getzf(oDay); //最后拼接时间
      return oTime;


    },
    // //补0操作
    getzf(num) {
      if (parseInt(num) < 10) {
        num = "0" + num;
      }
      return num;
    },
    content: function (row) {
      this.$refs.edit.open(row, "查看",true);
 
    },

    search() {
      this.list();
    },
    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams, this.page);
      api.list(params, (response) => {
        this.listData = response.data;
        this.listLoading = false;
      });
    },

    saveReadst(index, row) {
      let parameter = {
        id: row.id,
      };
      api.readst2(
        parameter,
        (response) => {
          this.$utils.msg.success(response.msg);
          this.list();
        },
        (response) => {
          this.$utils.msg.warning(response.msg);
        }
      );
    },
    //去添加
    toSave() {
      this.$refs.add.open({}, "添加");
    },
    // //去添加
    // toSave(index, row) {
    //   let editParameter = {
    //     id:  123,
    //     // cid: row.cid,
    //   };
    //   this.$refs.edit.open(editParameter, "添加");
    // },
    //去编辑
    toUpdate(index, row) {
      this.$refs.edit.open(row, "编辑",false);
    },

    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    //搜索
    search() {
      if (this.state == '未读') {
        this.searchParams.readst = 0;
      }
      if (this.state == '已读') {
        this.searchParams.readst = 1;
      }
      if (this.state == '全部') {
        this.searchParams.readst = undefined;
      }
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
      this.list();
    },//删除
    remove(index, row) {
      let parameter = {
        ids: row.id
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          response => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          response => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
  },
  mounted() {
    this.list();
    this.course =  this.$caches.myCourse.get();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>

